// src/components/HowItWorks.js
import React from "react";
import { Search } from 'lucide-react';

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-12 bg-transparent">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fadeInUp">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">How It's done :</h2>
        </div>

        <div className="relative grid lg:grid-cols-2 gap-16 items-center">
          <div className="aspect-video bg-gray-200 rounded-2xl flex items-center justify-center animate-fadeIn">
            <Search className="w-20 h-20 text-gray-400" />
          </div>

          <div className="space-y-6 ml-20"> {/* Increased base ml-20 to shift all steps right by 80px */}
            <div className="bg-white p-6 rounded-lg shadow-md w-85 h-40 flex items-center justify-center hover:shadow-lg hover:-translate-y-2 transition-all duration-300 transform ml-0">
              <div className="text-center">
                <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 font-bold">1</div>
                <h3 className="font-semibold text-gray-900 mb-2">Sign Up</h3>
                <p className="text-sm text-gray-600">Create an account to access our platform.</p>
              </div>
            </div>
            {/* <div className="bg-white p-6 rounded-lg shadow-md w-80 h-32 flex items-center justify-center hover:shadow-lg hover:-translate-y-2 transition-all duration-300 transform ml-10"> */}
            {/* <div className="text-center"> */}
            {/* <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 font-bold">2</div> */}
            {/* <h3 className="font-semibold text-gray-900 mb-2">Browse Data</h3> */}
            {/* <p className="text-sm text-gray-600">Explore available U.S. real estate datasets.</p> */}
            {/* </div> */}
            {/* </div> */}
            <div className="bg-white p-6 rounded-lg shadow-md w-85 h-40 flex items-center justify-center hover:shadow-lg hover:-translate-y-2 transition-all duration-300 transform ml-20">
              <div className="text-center">
                <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 font-bold">2</div>
                <h3 className="font-semibold text-gray-900 mb-2">Explore & Download</h3>
                <p className="text-sm text-gray-600">Explore real estate and download your selected data files.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;